import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

function requireEnv(name: string): string {
    const value = process.env[name];
    if (!value) {
        throw new Error(
            `Missing ${name}. Copy .env.example to .env and set your Firebase values.`
        );
    }
    return value;
}

// Firebase configuration (see .env.example)
export const firebaseConfig = {
    apiKey: requireEnv("REACT_APP_FIREBASE_API_KEY"),
    authDomain: requireEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
    projectId: requireEnv("REACT_APP_FIREBASE_PROJECT_ID"),
    storageBucket: requireEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: requireEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
    appId: requireEnv("REACT_APP_FIREBASE_APP_ID")
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
